<template>
  <div class="menu center">
    <sw-input
      ref="widhtInput"
      step="10"
      type="number"
      label="largeur"
      class="form-format-input"
      min="1"
      :max="getEditorMaxSize.maxWidth"
      :value="currentSize.w"
      :validators="sizeValidator"
      @input="previewSize"
    />
    <span style="font-size:14px">X</span>
    <sw-input
      ref="heightInput"
      step="10"
      type="number"
      label="hauteur"
      class="form-format-input"
      min="1"
      :max="getEditorMaxSize.maxHeight"
      :value="currentSize.h"
      :validators="sizeValidator"
      @input="previewSize"
    />
    <sw-button
      label="valider"
      class="button-valid-form center"
      @click="validSize"
      :disabled="!isValid"
    />
    <sw-button class="button-personnal-cancel" @click="cancel">
      <span>
        ou
        <span style="text-decoration:underline;">annuler</span>
      </span>
    </sw-button>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { EventBus, TEMPLATE_MODIFIED } from '@/model/EventBus'
import menu from '../menu-default'
import { lte } from 'junctions-fp'
export default {
  name: 'PersonnalFormat',
  mixins: [menu],
  components: {},
  beforeCreate() {},
  created() {
    this.currentSize = { w: this.getCurrentFormat.width, h: this.getCurrentFormat.height }
    this.maxSize = lte(this.getEditorMaxSize.maxWidth)
    this.sizeValidator  [{function: lte(this.getEditorMaxSize.maxWidth), message: `Max. :${this.getEditorMaxSize.maxWidth}` }]
    this.editor.changeFormat(this.currentSize.w, this.currentSize.h)
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      isValid: true,
      currentSize: { w: 800, h: 600 },
      maxSize: null,
      sizeValidator: []
    }
  },
  props: {},
  computed: {
    ...mapGetters(['getFormatList', 'getCurrentFormat', 'getEditorMaxSize'])
  },
  methods: {
    ...mapActions(['updateCurrentFormat']),

    previewSize(u) {
      this.isValid = this.maxSize(u)
      if (this.isValid) {
        const w = this.$refs.widhtInput.customValue
        const h = this.$refs.heightInput.customValue
        this.currentSize = { w, h }
        this.editor.changeFormat(w, h)
      }
    },
    validSize() {
      this.editor.changeFormat(this.currentSize.w, this.currentSize.h)
      const f = {
        format: 'publication',
        width: this.currentSize.w,
        height: this.currentSize.h,
        network: 'personnal',
        font: 'fa',
        icon: 'user',
        label: 'personnal'
      }
      this.updateCurrentFormat(f)
      EventBus.$emit(TEMPLATE_MODIFIED)
      this.changeMenu('DefaultMenu')
    },
    cancel() {
      const f = this.getCurrentFormat
      this.editor.changeFormat(f.width, f.height)
      this.$emit('backMenu')
    }
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/menu/format/PersonnalFormat.vue